import { Component, Input, signal } from '@angular/core';
import { IProductCarousel } from '@web-nx-ng-tsc/web-shared-data-access';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { ReplaceBucket } from '@web-nx-ng-tsc/util-func';

@Component({
  selector: 'web-promo-shared-pattern-lib-product-prop-carousel',
  imports: [CarouselModule],
  templateUrl: './lib-product-prop-carousel.component.html',
  styleUrl: './lib-product-prop-carousel.component.scss',
})
export class LibProductPropCarouselComponent {
  @Input() set data(value: IProductCarousel[]) {
    this.dataSignal.set(value);
  }

  public readonly replaceBucket = new ReplaceBucket();
  dataSignal = signal<IProductCarousel[]>([]);

  carouselOptions = {
    loop: true,
    nav: true, // Enable navigation
    dots: false,
    autoplay: false,
    lazyLoad: true,
    autoplayTimeout: 3000,
    navText: ['<i class="fa fa-angle-left" style="align-content:center;"></i>', '<i class="fa fa-angle-right"></i>'],
    responsive: {
      0: {
        items: 1.18, // Show 1.5 items on smaller screens
        stagePadding: 10,
      },
      600: {
        items: 3.05,
        stagePadding: 30,
      },
    },
  };
}
